import * as Attributes from '../attributes'
import * as Members from '../constants'
import * as Types from './types'

export const ADD_MEMBER = 'ADD_MEMBER'

export const ADD_MEMBER_ATTRIBUTE = 'ADD_MEMBER_ATTRIBUTE'
export const CLICK_MEMBER_ATTRIBUTE = 'CLICK_MEMBER_ATTRIBUTE'
export const EDIT_MEMBER_ATTRIBUTE = 'EDIT_MEMBER_ATTRIBUTE'
export const SERVER_RESOURCE = Members.SERVER_RESOURCE

export const emptyModalState: Types.ModalData = {
  attributes: [],
  email: '',
  first_name: '',
  last_name: '',
}

export const newMemberState = (attrs: Attributes.AvailableAttributes): Types.ModalData => {
  return {
    ...emptyModalState,
    attributes: attrs.map((a: Attributes.AvailableAttribute, idx: number) => ({
      index: idx,
      name: a.key,
      value: '',
    })),
  }
}



// WEBPACK FOOTER //
// ./src/pages/members/add-modal/constants.ts